import { Illustration, Table, Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useMemo } from 'react';
import { DimensionValue, FlatList } from 'react-native';

import { TradingCustomerProfileItem } from '../../../../store/trading/types';

import { Head } from './components/Head';
import { TradingListItem } from './components/Item';
import { rowHeight, maxHeightMobile, maxHeight } from './constants';

export interface ItemData {
  sendId: string;
  monthCompetence: string;
  type: string;
  billedCustomers: number;
  sendDate: string;
  total: string;
  status: string;
}

interface TradingCustomerListTableProps {
  isMobile?: boolean;
  tradingList?: TradingCustomerProfileItem[];
  onLoadMore?: () => void;
  filtered: boolean;
  handleNavigate: ({
    currentSinacorAccount,
    currentIdAccount,
    currentAccountPNP,
    currentAccountBP,
  }) => void;
  renderedItems?: number;
}

export const TradingCustomerListTable: React.FC<TradingCustomerListTableProps> = ({
  isMobile,
  tradingList,
  onLoadMore,
  renderedItems,
  filtered,
  handleNavigate,
}) => {
  const deviceType = useBreakpointValue({ md: 'desktop', base: 'tablet' });

  const content = useMemo(() => {
    if (!tradingList?.length && !filtered) {
      return (
        <VStack alignItems="center" paddingY={Spacing['stack.xxxl']}>
          <VStack alignItems="center" space={Spacing['stack.quarck']}>
            <Illustration name="NotFoundIllustration" testId={'empty-illustration'} />
            <Text
              textAlign={'center'}
              paddingTop={Spacing['stack.xxxs']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              variant="bold"
              color="neutral.black">
              Você não possui clientes operando.
            </Text>
            <Text
              textAlign={'center'}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              lineHeight="medium"
              color="neutral.black">
              Pesquise o cliente por conta sinacor sem o dígito.
            </Text>
          </VStack>
        </VStack>
      );
    }

    return (
      <VStack flex={1} {...(isMobile && { height: maxHeightMobile?.toString() })}>
        {isMobile ? (
          <FlatList
            data={tradingList?.slice(0, renderedItems)}
            contentContainerStyle={{ height: maxHeightMobile }}
            renderItem={({ item }) => (
              <TradingListItem handleNavigate={handleNavigate} item={item} />
            )}
            keyExtractor={(item) => item.contaSinacorSemDigito!.toString()}
            showsVerticalScrollIndicator={false}
            onEndReached={onLoadMore}
          />
        ) : (
          <Table rows={4} cols={7} rowHeight={rowHeight} isLoading={false}>
            {deviceType === 'desktop' && <Head />}
            <FlatList
              data={tradingList?.slice(0, renderedItems)}
              contentContainerStyle={{ maxHeight }}
              style={{
                marginLeft: `-${Spacing['inline.xxs']}` as DimensionValue,
                marginRight: `-${Spacing['inline.xxs']}` as DimensionValue,
              }}
              renderItem={({ item }) => (
                <TradingListItem handleNavigate={handleNavigate} item={item} />
              )}
              keyExtractor={(item) => item.contaSinacorSemDigito!.toString()}
              showsVerticalScrollIndicator={false}
              onEndReached={onLoadMore}
            />
          </Table>
        )}
      </VStack>
    );
  }, [tradingList, filtered, isMobile, onLoadMore, deviceType, renderedItems, handleNavigate]);

  return <Box flex={1}>{content}</Box>;
};
